export function toBooleanProperty(value: string | boolean): boolean {
  return value !== null && `${value}` !== 'false';
}
